/*
 * Constants.
 */

// All size values are in pixels.

export const thumbnailSquareSize = 100;
export const gridSpacing = 4;

// Row height is 104px.
export const rowHeight = thumbnailSquareSize + gridSpacing;

export const gifsPerRow = 3;

// Container is 316px wide: 300px for the three images and four 4px grid gaps.
export const dropdownWidth = 316;

// This is the search results portion of the dropdown, which is less than the entire dropdown height.
// This results in a total dropdown height of 428px, matching the emoji picker.
export const dropdownListHeight = 296;
